import { GridComponent } from '@progress/kendo-angular-grid';

/**
 * Re-fits the columns to their content, then hands the leftover grid width to the last column on screen,
 * or, with `distributeEvenly`, spreads it over all visible columns.
 *
 * `grid.columnList` stays in template order, so the on-screen last column (the one the leftover width
 * belongs to) has to be derived from `orderIndex` - columns can be reordered by the user.
 * Shared by `BaseKendoList` and `ExtendedBaseTab`.
 */
export function fitColumnsToGrid(grid: GridComponent, distributeEvenly = false): void {
    const columns = grid.columnList.toArray();
    grid.autoFitColumns();
    const totalWidthWithoutHidden = columns.reduce((sum, column) => (column.hidden ? sum : sum + column.width), 0);
    const showDetailColumnWidth = grid.detailTemplate ? 50 : 0;
    const availableWidth = grid.wrapper.nativeElement.offsetWidth - showDetailColumnWidth - 17;
    const widthDelta = availableWidth - totalWidthWithoutHidden;
    if (widthDelta <= 0) {
        return;
    }

    const visibleColumns = columns.filter((column) => !column.hidden);
    if (distributeEvenly) {
        if (visibleColumns.length) {
            const share = widthDelta / visibleColumns.length;
            visibleColumns.forEach((column) => (column.width += share));
        }
        return;
    }

    const lastOnScreen = visibleColumns.sort((a, b) => a.orderIndex - b.orderIndex).pop();
    if (lastOnScreen) {
        lastOnScreen.width += widthDelta;
    }
}
